export enum DefaultBankCode {
  Sberbank = 'sberbank',
  Tinkoff = 'tinkoff',
  Amobile = 'amobile',
  Amra = 'amra-bank',
  BISA = 'bisa',
}
